import { useRef, useEffect, useState } from "react";
import heroGradient from "@/assets/hero-gradient.jpg";

export function MarqueeBanner() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const windowH = window.innerHeight;
      // progress: 0 when section enters bottom, 1 when it leaves top
      const raw = 1 - (rect.bottom / (windowH + rect.height));
      setProgress(Math.max(0, Math.min(1, raw)));
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Skew goes from -6deg → 0 → +6deg as you scroll through
  const skew = (progress - 0.5) * 12;
  // Horizontal translate for marquee movement
  const translateX = (progress - 0.5) * -200;
  // Gradient opacity fades out
  const gradientOpacity = Math.max(0, 1 - progress * 1.5);

  const text = "reelistiq";
  const separator = " • ";
  const repeated = Array(6).fill(text).join(separator) + separator;

  return (
    <section
      ref={sectionRef}
      className="relative overflow-hidden py-16 md:py-24"
      style={{ backgroundColor: "hsl(var(--foreground))" }}
    >
      {/* Gradient bleed from hero */}
      <img
        src={heroGradient}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover pointer-events-none transition-opacity duration-300"
        style={{ opacity: gradientOpacity }}
      />

      {/* Content */}
      <div className="relative z-10">
        {/* Row 1 */}
        <div
          className="whitespace-nowrap font-display font-bold uppercase select-none"
          style={{
            transform: `skewY(${skew}deg) translateX(${translateX}px)`,
            willChange: "transform",
            fontSize: "clamp(4rem, 12vw, 12rem)",
            lineHeight: 1,
            color: "hsl(var(--accent))",
          }}
        >
          {repeated}
        </div>

        {/* Row 2 — offset and reversed direction */}
        <div
          className="whitespace-nowrap font-display font-bold uppercase select-none mt-2 md:mt-4"
          style={{
            transform: `skewY(${skew}deg) translateX(${-translateX - 100}px)`,
            willChange: "transform",
            fontSize: "clamp(4rem, 12vw, 12rem)",
            lineHeight: 1,
            color: "hsl(var(--accent))",
            opacity: 0.6,
          }}
        >
          {repeated}
        </div>
      </div>
    </section>
  );
}
